// import "/sticky_kit.js";
// import "/owl.carousel.min";
// const router = require("../../data/router");

// Reason for double stringify: ¯\_(ツ)_/¯
name = JSON.stringify("page_data").replace(/\"/g, "");
localStorage.setItem(name, JSON.stringify({
  "tn": {
    "name": "TN",
    "product": "T&N Original Mattress",
    "price": 695,
    "reviews": {
      "amazon": "5,722",
      "google": "13,322",
      "sleepers": 1439484,
      "sleepters_updated": "11/20/2019",
      "internal": "133,082"
    },
    "bbb": {
      "rating": "A+",
      "reviews": 175,
      "accredited": true,
      "complaints": 3
    },
    "certifications": {
      "certipur": true,
      "greenguard": true
    },
    "testimonials": null
  },
  "endy": {
    "name": "Endy",
    "product": "Endy Mattress",
    "price": 17395,
    "reviews": {
      "amazon": "13099",
      "google": null,
      "sleepers": null,
      "sleepters_updated": null,
      "internal": null,
    },
    "bbb": {
      "rating": "Not accredited",
      "reviews": "0",
      "accredited": false,
      "complaints": "Not accredited",
    },
    "certifications": {
      "certipur": true,
      "greenguard": false,
    },
    "testimonials": null,
  },
  "douglas": {
    "name": "Douglas",
    "product": "Original Douglas Mattress",
    "price": 6927,
    "reviews": {
      "amazon": "5657",
      "google": null,
      "sleepers": null,
      "sleepters_updated": null,
      "internal": null,
    },
    "bbb": {
      "rating": "A+",
      "reviews": 122,
      "accredited": true,
      "complaints": 3,
    },
    "certifications": {
      "certipur": true,
      "greenguard": false,
    },
    "testimonials": null,
  },
  "purple": {
    "name": "Purple",
    "product": "Purple Memory Foam Mattress",
    "price": 18909,
    "reviews": {
      "amazon": "20468",
      "google": null,
      "sleepers": null,
      "sleepters_updated": null,
      "internal": null,
    },
    "bbb": {
      "rating": "A+",
      "reviews": 42,
      "accredited": true,
      "complaints": 113,
    },
    "certifications": {
      "certipur": true,
      "greenguard": true,
    },
    "testimonials": null,
  },
  "leesa": {
    "name": "Leesa",
    "product": "Leesa Mattress",
    "price": 14081,
    "reviews": {
      "amazon": "16912",
      "google": null,
      "sleepers": null,
      "sleepters_updated": null,
      "internal": null,
    },
    "bbb": {
      "rating": "A+",
      "reviews": 3,
      "accredited": true,
      "complaints": 13,
    },
    "certifications": {
      "certipur": true,
      "greenguard": false,
    },
    "testimonials": null,
  },
  "casper": {
    "name": "Casper",
    "product": "Casper Mattress",
    "price": 13980,
    "reviews": {
      "amazon": "18865",
      "google": null,
      "sleepers": null,
      "sleepters_updated": null,
      "internal": null,
    },
    "bbb": {
      "rating": "A+",
      "reviews": 18,
      "accredited": true,
      "complaints": 47,
    },
    "certifications": {
      "certipur": true,
      "greenguard": false,
    },
    "testimonials": null,
  }

}));

const competitors = JSON.parse(localStorage.getItem("page_data"));

function userIsMobile() {
  return (
    typeof window.orientation !== "undefined" ||
    navigator.userAgent.indexOf("IEMobile") !== -1
  );
}

(function () {
  let custom_competitor = window.location.pathname
    .split(/\//)
    .filter(x => x)
    .filter(y => y !== "compare")[0];
  if (custom_competitor && custom_competitor !== "endy") {
    $("body .main-content").addClass(`competitor-${custom_competitor}`);
    //$("body .main-content").addClass(`competitor-${custom_competitor}`);
  }

  // let $star_groups = $("[data-competitor-bbb_reviews]");

  // let updateStars = stars => {
  //   const STAR_COLOR_EMPTY = "#D8D8D8";
  //   const STAR_COLOR_FILL = "#F1B31C";
  //   let $stars = $(stars),
  //     rating = $stars.data("competitor-bbb_reviews"),
  //     full_stars = Math.floor(rating),
  //     half_star = rating % 1 > 0;

  //   $stars.find("svg [fill]").css("fill", STAR_COLOR_EMPTY);
  //   $stars.find("svg #half_fill").css("fill", "transparent");
  //   $stars
  //     .find(`svg:nth-child(-n+${full_stars})`)
  //     .find("[fill]")
  //     .css("fill", STAR_COLOR_FILL);
  //   if (half_star) {
  //     $stars
  //       .find(`svg:nth-child(${full_stars + 1})`)
  //       .find("#half_fill")
  //       .css("fill", STAR_COLOR_FILL);
  //   }
  // };

  let modalToggle = hide => {
    $("#modal_certifications").toggleClass("hide", hide);
  };

  // $.each($star_groups, (i, stars) => {
  //   updateStars(stars);
  // });

  $("[data-modal-certifications]").on("click", () => {
    modalToggle(false);
  });

  $("[data-modal-close]").on("click", () => {
    modalToggle(true);
  });

  let owl = $("[data-owl-carousel]").owlCarousel({
    nav: false,
    loop: true,
    items: 3,
    slideBy: 3,
    responsive: {
      0: {
        items: 1,
        slideBy: 1,
        margin: 20
      },
      768: {
        items: 2,
        slideBy: 2,
      },
      1000: {
        items: 3
      }
    }
  });

  $("[data-reviews-prev]").on("click", function () {
    owl.trigger("prev.owl.carousel");
  });

  $("[data-reviews-next]").on("click", () => {
    owl.trigger("next.owl.carousel");
  });

  $("[data-offset_top]").each(function () {
    $(this).stick_in_parent({
      offset_top: parseInt($(this).attr("data-offset_top"))
    });
  });

  function initControls() {
    const DROPDOWN_DATA_ATTR = "data-component-dropdown_competitor_col";
    let $dropdown = $(`.competitor [${DROPDOWN_DATA_ATTR}]`),
      $button = $dropdown.find("button"),
      $options = $dropdown.find("ul li input[type=radio]");

    $button.off("click.tn_dropdown_show_brand_options");
    $button.on("click.tn_dropdown_show_brand_options", function (e) {
      e.preventDefault();
      e.stopPropagation();
      
      let $this_dropdown = $(this).closest(`[${DROPDOWN_DATA_ATTR}]`);
      $this_dropdown.toggleClass("active");
      if (!$this_dropdown.hasClass("active")) {
        return;
      }
      $(document.body).one("click", function () {
        $this_dropdown.removeClass("active");
      });
    });

    $options.off("click.tn_dropdown_change_brand_option");
    $options.on("click.tn_dropdown_change_brand_option", function (e) {
      e.preventDefault();
      e.stopPropagation();
      
      let $this = $(this),
        selected_competitor = $this[0].value,
        col_num = $this
          .closest(`[${DROPDOWN_DATA_ATTR}]`)
          .data("component-dropdown_competitor_col"),
        $cell_group = $(`#compare .competitor.column_${col_num}`);
    
      // On mobile screen widths the dropdown should change the reviews at the bottom to match the selection
      if (userIsMobile()) {
        $tabs.each(function () {
          var $this = $(this),
            $active_tabs = $this.find("ul li.active");
          if ($active_tabs.length !== 1) {
            var $active_tab = $this.find(
              `ul li[data-component-details-id="${selected_competitor}"]`
            );
            fnActivatePane($active_tab);
          }
        });
      }

      $cell_group
        .find("[data-competitor-name]")
        .html(`${competitors[selected_competitor].name}`);
      $cell_group
        .find("[data-competitor-product_name]")
        .html(`${competitors[selected_competitor].product}`);
      $cell_group
        .find("[data-competitor-price]")
        .html(`${competitors[selected_competitor].price}`);
        //.html(`$${competitors[selected_competitor].price}`);
      $cell_group
        .find("[data-tn-save]")
        /* .html(
          `Save $${competitors[selected_competitor].price -
          competitors.tn.price} with T&N`
        ); */
        .html(
          `Save $${competitors[selected_competitor].price -
          competitors.tn.price} with T&N`
        );
      $cell_group
        .find("[data-competitor-amazon_reviews]")
        .html(`${competitors[selected_competitor].reviews.amazon}`);
      $cell_group
        .find("[data-competitor-bbb_rating]")
        .html(`${competitors[selected_competitor].bbb.rating}`);

      $cell_group
        .find("[data-competitor-bbb_reviews]")
        .html(`${competitors[selected_competitor].bbb.reviews}`);
        //   "competitor-bbb_reviews",
        //   competitors[selected_competitor].bbb.reviews
        // );
      // updateStars($cell_group.find("[data-competitor-bbb_reviews]"));

      $cell_group
        .filter("[data-competitor-bbb_accredited]")
        .removeClass("info_true info_false")
        .addClass(
          `${
          competitors[selected_competitor].bbb.accredited
            ? "info_true"
            : "info_false"
          }`
        );
      $cell_group
        .find("[data-competitor-bbb_complaints]")
        .html(`${competitors[selected_competitor].bbb.complaints}`);
      $cell_group
        .filter("[data-competitor-certifications_certipur]")
        .removeClass("info_true info_false")
        .addClass(
          `${
          competitors[selected_competitor].certifications.certipur
            ? "info_true"
            : "info_false"
          }`
        );
      $cell_group
        .filter("[data-competitor-certifications_greenguard]")
        .removeClass("info_true info_false")
        .addClass(
          `${
          competitors[selected_competitor].certifications.greenguard
            ? "info_true"
            : "info_false"
          }`
        );
      $cell_group
        .filter("[data-competitor-certifications_Intertek]")
        .removeClass("info_true info_false")
        .addClass(
          `${
          competitors[selected_competitor].certifications_Intertek
            ? "info_true"
            : "info_false"
          }`
        );
      $cell_group
        .find("[data-competitor-more_info]")
      // .attr("href", router[selected_competitor]);
    });

    let $tabs = $("[data-component-tabs]"),
      fnActivatePane = function ($tab) {
        let brand = $tab.find("a").html();
        $tab.siblings("li").removeClass("active");
        $tab.addClass("active");

        $tab
          .closest("#reviews")
          .find(
            `[data-component-dropdown_reviews] ul li label[for=${brand}_option]`
          )
          .click();
        $tab
          .closest("#reviews")
          .find("[data-component-dropdown_reviews] button")
          .html(`${brand}`);

        var $detail_panes = $tab
          .closest("ul")
          .siblings("[data-component-details]");
        $detail_panes.hide();
        $detail_panes
          .filter(
            "#" + $tab.data("component-details-id") + "[data-component-details]"
          )
          .show();
      };

    $tabs.each(function () {
      var $this = $(this),
        $active_tabs = $this.find("ul li.active");
      if (!$active_tabs.length || $active_tabs.length > 1) {
        var $active_tab = $this.find("ul li:first-child");
        if (custom_competitor) {
          $active_tab = $this.find(
            `ul li[data-component-details-id="${custom_competitor}"]`
          );
        }
        fnActivatePane($active_tab);
      }
    });

    $tabs.find("ul li a").off("click.tn_tabs_show_detail");
    $tabs.find("ul li a").on("click.tn_tabs_show_detail", function (e) {
      e.preventDefault();
      var $active_tab = $(this).closest("li");
      fnActivatePane($active_tab);
    });

    const REVIEW_DROPDOWN_DATA_ATTR = "data-component-dropdown_reviews";
    let $review_dd = $(`#reviews [${REVIEW_DROPDOWN_DATA_ATTR}]`),
      $review_dd_button = $review_dd.find("button"),
      $review_dd_options = $review_dd.find("ul li input[type=radio]");

    $review_dd_button.off("click.tn_dropdown_show_brand_options");
    $review_dd_button.on("click.tn_dropdown_show_brand_options", function (e) {
      e.preventDefault();
      e.stopPropagation();

      let $this_dropdown = $(this).closest(`[${REVIEW_DROPDOWN_DATA_ATTR}]`);
      $this_dropdown.toggleClass("active");
      if (!$this_dropdown.hasClass("active")) {
        return;
      }
      $(document.body).one("click", function () {
        $this_dropdown.removeClass("active");
      });
    });

    $review_dd_options.off("change.tn_dropdown_change_brand_option");
    $review_dd_options.on("change.tn_dropdown_change_brand_option", function () {
      var $this = $(this),
        dropdown_html = $this.siblings("label").html();
      $this.closest(`[${REVIEW_DROPDOWN_DATA_ATTR}]`).addClass("dirty");
      $this
        .closest("ul")
        .siblings("button")
        .html(dropdown_html);

      $tabs
        .find(
          `ul li[data-component-details-id=${dropdown_html.toLowerCase()}] a`
        )
        .click();
    });
  }


  initControls();
})();
